import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { Shirt, CheckCircle2 } from "lucide-react";

export default function ShirtSize() {
  const params = new URLSearchParams(window.location.search);
  const kind = params.get("kind") || "participant";
  const id = params.get("id") || "";
  const [rec, setRec] = useState(null);
  const [size, setSize] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!id) { setError("This link is missing its info."); return; }
    api.shirtLookup(kind, id)
      .then((d) => { setRec(d); setSize(d.shirt_size || ""); })
      .catch((e) => setError(e?.response?.data?.detail || "We couldn't find your entry."));
  }, [kind, id]);

  const submit = async () => {
    setError("");
    if (!size) { setError("Please pick a size."); return; }
    setBusy(true);
    try {
      await api.shirtUpdate(kind, id, size);
      setDone(true);
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not save. Try again.");
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="max-w-md mx-auto p-4 pt-16 text-center" data-testid="shirt-done">
        <div className="brutal p-6">
          <CheckCircle2 size={56} className="mx-auto text-green-600 mb-3" />
          <h1 className="font-display text-3xl font-black uppercase tracking-tight">Got It — Mahalo!</h1>
          <p className="font-display text-gray-600 mt-2">Your T-shirt size (<strong>{size}</strong>) is saved. See you at Pounders!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-4 pt-12" data-testid="shirt-view">
      <div className="flex items-center gap-2 mb-1">
        <Shirt size={28} />
        <h1 className="font-display text-4xl font-black uppercase tracking-tight">Your Shirt Size</h1>
      </div>
      <p className="font-display text-gray-500 uppercase text-xs tracking-widest mb-6">Pounders Fest 2026</p>
      <div className="brutal p-4">
        {rec && <p className="font-display mb-3">Aloha <strong>{rec.name}</strong>, pick your T-shirt size below.</p>}
        <select data-testid="shirt-select" value={size} onChange={(e) => setSize(e.target.value)} className="w-full brutal-2 p-3 font-display focus:outline-none bg-white mb-3">
          <option value="">Select a size…</option>
          {(rec?.sizes || []).map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        {error && <p className="text-[#E63946] font-bold uppercase text-sm mb-2" data-testid="shirt-error">{error}</p>}
        <button data-testid="shirt-submit" onClick={submit} disabled={busy || !rec} className="w-full bg-black text-white font-display font-black uppercase tracking-widest py-4 active:scale-95 transition-transform disabled:opacity-60">
          {busy ? "Saving…" : "Save My Size"}
        </button>
      </div>
    </div>
  );
}
